module.exports = __webpack_public_path__ + "img/ultratech-cement-logo.3a2310be.png";